export default "__VITE_ASSET__ae0fd0c8__"